import N from "openapi-fetch";
import D from "lodash.isequal";
import { v4 as E } from "uuid";
const F = (_) => {
  console.log(_.error);
}, V = (_) => {
  const a = N({
    baseUrl: _.baseUrl
  }), n = {
    onRequest: _.onRequest,
    onResponse: _.onResponse,
    onError: _.onError || F
  };
  return a.use(n), a;
};
class j {
  constructor({ config: a }) {
    var h, s;
    this.userToken = null, this.constructClientOptions = (e) => {
      const t = this.config.apiUrl || "https://api.open.cx", o = {
        "X-Bot-Token": this.config.token,
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: e ? `Bearer ${e}` : void 0
      };
      return { baseUrl: t, headers: o };
    }, this.createOpenAPIClient = ({
      baseUrl: e,
      headers: t
    }) => V({
      baseUrl: e,
      onRequest: ({ request: o }) => {
        Object.entries(t).forEach(([i, l]) => {
          l && o.headers.set(i, l);
        });
      }
    }), this.setAuthToken = (e) => {
      this.userToken = e;
      const { baseUrl: t, headers: o } = this.constructClientOptions(e);
      this.client = this.createOpenAPIClient({ baseUrl: t, headers: o });
    }, this.getExternalWidgetConfig = async () => await this.client.GET("/backend/widget/v2/config", {
      params: { header: { "X-Bot-Token": this.config.token } }
    }), this.sendMessage = async (e, t) => await this.client.POST("/backend/widget/v2/chat/send", {
      body: e,
      signal: t
    }), this.createUnverifiedContact = async (e) => await this.client.POST(
      "/backend/widget/v2/contact/create-unverified",
      {
        params: { header: { "x-bot-token": this.config.token } },
        body: e
      }
    ), this.createSession = async (e) => await this.client.POST("/backend/widget/v2/create-session", {
      body: e
    }), this.pollSessionAndHistory = async ({
      sessionId: e,
      lastMessageTimestamp: t,
      abortSignal: o
    }) => {
      const i = t ? { lastMessageTimestamp: t } : void 0;
      return await this.client.GET("/backend/widget/v2/poll/{sessionId}", {
        params: { path: { sessionId: e }, query: i },
        signal: o
      });
    }, this.getSessions = async ({
      cursor: e,
      filters: t,
      abortSignal: o
    }) => await this.client.GET("/backend/widget/v2/sessions", {
      params: { query: { cursor: e, filters: JSON.stringify(t) } },
      signal: o
    }), this.uploadFile = async ({
      file: e,
      abortSignal: t,
      onProgress: o
    }) => new Promise((i, l) => {
      var y;
      const c = new FormData();
      c.append("file", e);
      const u = new XMLHttpRequest();
      if (t && (t.addEventListener("abort", () => {
        u.abort(), l(new DOMException("Aborted", "AbortError"));
      }), t.aborted)) {
        l(new DOMException("Aborted", "AbortError"));
        return;
      }
      u.upload.addEventListener("progress", (v) => {
        if (v.lengthComputable && o) {
          const b = Math.round(v.loaded / v.total * 100);
          o(b);
        }
      }), u.addEventListener("load", () => {
        if (u.status >= 200 && u.status < 300)
          try {
            const v = JSON.parse(u.responseText);
            i(v);
          } catch (v) {
            l(new Error(`Failed to parse response: ${v}`));
          }
        else
          l(new Error(`Upload failed with status: ${u.status}`));
      }), u.addEventListener("error", () => {
        l(new Error("Network error occurred"));
      }), u.addEventListener("timeout", () => {
        l(new Error("Upload timed out"));
      });
      const { baseUrl: p } = this.constructClientOptions(this.userToken), d = `${p}/backend/widget/v2/upload`;
      u.open("POST", d), u.setRequestHeader("X-Bot-Token", this.config.token), this.userToken ?? ((y = this.config.user) == null ? void 0 : y.token) ? u.setRequestHeader("Authorization", `Bearer ${this.userToken}`) : console.error("User token not set"), u.send(c);
    }), this.vote = async (e) => await this.client.POST("/backend/widget/v2/chat/vote", { body: e }), this.resolveSession = async (e, t) => await this.client.POST("/backend/widget/v2/session/resolve", {
      body: e,
      signal: t
    }), this.createStateCheckpoint = async (e) => await this.client.POST("/backend/widget/v2/checkpoint", {
      body: e
    }), this.submitCsat = async (e) => await this.client.POST("/backend/widget/v2/submit-csat", { body: e }), this.config = a, this.userToken = ((h = a.user) == null ? void 0 : h.token) || null;
    const { baseUrl: n, headers: r } = this.constructClientOptions(
      (s = a.user) == null ? void 0 : s.token
    );
    this.client = this.createOpenAPIClient({ baseUrl: n, headers: r });
  }
}
function B(_, a) {
  console.error(`Missing case for ${_} in ${a}`);
}
class S {
  constructor(a) {
    this.subscribers = /* @__PURE__ */ new Set(), this.get = () => this.state, this.set = (n) => {
      D(this.state, n) || (this.state = n, this.notifySubscribers(n));
    }, this.setPartial = (n) => {
      if (n == null) return;
      const r = { ...this.state, ...n };
      this.set(r);
    }, this.reset = () => {
      this.set(this.initialState);
    }, this.notifySubscribers = (n) => {
      Array.from(this.subscribers).forEach((h) => {
        try {
          h(n);
        } catch (s) {
          console.error(s);
        }
      });
    }, this.subscribe = (n) => (this.subscribers.add(n), () => {
      this.subscribers.delete(n);
    }), this.state = a, this.initialState = a;
  }
}
class U {
  constructor() {
    this.state = new S({
      isPolling: !1,
      isError: !1
    }), this.abortController = new AbortController(), this.reset = () => {
      var a;
      this.abortController.abort("Resetting poller"), (a = this.stopPolling) == null || a.call(this), this.stopPolling = null;
    }, this.stopPolling = null, this.startPolling = (a, n) => {
      if (this.stopPolling) return;
      const r = [], h = async () => {
        this.abortController = new AbortController(), this.state.setPartial({ isPolling: !0 });
        try {
          await a(this.abortController.signal);
        } catch (s) {
          if (this.abortController.signal.aborted)
            return;
          console.error("Failed to poll:", s), this.state.setPartial({ isError: !0 });
        } finally {
          this.state.setPartial({ isPolling: !1 });
        }
        this.abortController.signal.aborted ? console.log("Poller aborted, not scheduling anymore") : r.push(setTimeout(h, n));
      };
      h(), this.stopPolling = () => {
        r.forEach(clearTimeout), this.state.reset();
      };
    };
  }
}
function L(_) {
  try {
    const a = _();
    return a instanceof Promise ? a.then((n) => ({ data: n })).catch((n) => ({ error: n })) : { data: a };
  } catch (a) {
    return { error: a };
  }
}
class K {
  constructor({
    api: a,
    config: n,
    sessionCtx: r,
    messageCtx: h,
    sessionPollingIntervalSeconds: s
  }) {
    this.poller = new U(), this.fetchSessionAndFullHistoryAbortController = new AbortController(), this.registerPolling = () => {
      this.sessionCtx.sessionState.subscribe(({ session: e }) => {
        e != null && e.id ? this.poller.startPolling(async (t) => {
          this.fetchSessionAndHistory({ sessionId: e.id, abortSignal: t });
        }, this.sessionPollingIntervalSeconds * 1e3) : this.poller.reset();
      }), this.sessionCtx.sessionState.subscribe(({ session: e }) => {
        if (e != null && e.id && !e.isOpened)
          try {
            this.fetchSessionAndFullHistoryAbortController = new AbortController(), this.fetchSessionAndHistory({
              sessionId: e.id,
              abortSignal: this.fetchSessionAndFullHistoryAbortController.signal,
              fetchFullHistory: !0
            });
          } catch (t) {
            this.fetchSessionAndFullHistoryAbortController.signal.aborted || console.error("Failed to fetch session and full history:", t);
          }
        else
          this.fetchSessionAndFullHistoryAbortController.abort();
      });
    }, this.fetchSessionAndHistory = async ({
      sessionId: e,
      abortSignal: t,
      fetchFullHistory: o = !1
    }) => {
      var u;
      this.messageCtx.state.get().messages.length === 0 && this.messageCtx.state.setPartial({ isInitialFetchLoading: !0 });
      const i = this.messageCtx.state.get().messages, l = i.length > 0 ? ((u = i[i.length - 1]) == null ? void 0 : u.timestamp) ?? void 0 : void 0, { data: c } = await this.api.pollSessionAndHistory({
        sessionId: e,
        abortSignal: t,
        lastMessageTimestamp: o ? void 0 : l
      });
      if (c != null && c.session && (this.sessionCtx.sessionState.setPartial({ session: c.session }), this.sessionCtx.setSessions([c.session])), c != null && c.history && c.history.length > 0) {
        const p = this.messageCtx.state.get().messages, w = c.history.map(this.mapHistoryToMessage).filter((d) => d !== null).filter(
          (d) => !p.some((k) => k.id === d.id)
        );
        this.messageCtx.state.setPartial({
          messages: [...p, ...w]
        });
      }
      this.messageCtx.state.get().isInitialFetchLoading && this.messageCtx.state.setPartial({ isInitialFetchLoading: !1 });
    }, this.mapHistoryToMessage = (e) => {
      var o;
      const t = {
        id: e.publicId,
        timestamp: e.sentAt || "",
        attachments: e.attachments || void 0
      };
      if (e.sender.kind === "user")
        return {
          ...t,
          type: "USER",
          content: e.content.text || "",
          deliveredAt: e.sentAt || ""
        };
      if (e.sender.kind === "agent")
        return {
          ...t,
          type: "AGENT",
          component: "agent_message",
          data: {
            message: e.content.text || ""
          },
          agent: {
            name: e.sender.name || "",
            // Do not set avatarUrl from config here... let it be taken from the config at render time
            // Only set avatar url from the backend's response
            avatarUrl: e.sender.avatar || null,
            avatar: e.sender.avatar || null,
            id: null,
            isAi: !1
          }
        };
      if (e.sender.kind === "ai") {
        const i = e.actionCalls && e.actionCalls.length > 0 ? e.actionCalls[e.actionCalls.length - 1] : void 0;
        return {
          ...t,
          type: "AI",
          component: "bot_message",
          agent: {
            id: null,
            name: ((o = this.config.bot) == null ? void 0 : o.name) || "",
            isAi: !0,
            // Do not set avatarUrl from config here... let it be taken from the config at render time
            avatarUrl: null,
            avatar: null
          },
          data: {
            message: e.content.text || "",
            action: i ? {
              name: i.actionName,
              data: this.extractActionResult(i)
            } : void 0
          }
        };
      }
      if (e.sender.kind === "system") {
        const i = this.constructSystemMessage(e);
        return i === null ? null : { ...i };
      }
      return null;
    }, this.constructSystemMessage = (e) => {
      if (!e || !e.systemMessagePayload) return null;
      switch (e.systemMessagePayload.type) {
        case "state_checkpoint":
          return {
            id: e.publicId,
            type: "SYSTEM",
            subtype: "state_checkpoint",
            data: { payload: e.systemMessagePayload.payload },
            timestamp: e.sentAt || "",
            attachments: void 0
          };
        case "csat_requested":
          return {
            id: e.publicId,
            type: "SYSTEM",
            subtype: "csat_requested",
            data: { payload: void 0 },
            timestamp: e.sentAt || "",
            attachments: void 0
          };
        case "csat_submitted":
          return {
            id: e.publicId,
            type: "SYSTEM",
            subtype: "csat_submitted",
            data: {
              payload: {
                score: e.systemMessagePayload.payload.score ?? void 0,
                feedback: e.systemMessagePayload.payload.feedback ?? void 0
              }
            },
            timestamp: e.sentAt || "",
            attachments: void 0
          };
        case "none":
          return null;
        default:
          return B(
            e.systemMessagePayload,
            this.constructSystemMessage.name
          ), null;
      }
    }, this.extractActionResult = (e) => {
      const t = e.result;
      if (t === null || typeof t != "object") return t;
      if ("responseBodyText" in t && typeof t.responseBodyText == "string") {
        const o = t.responseBodyText, i = L(() => JSON.parse(o)).data;
        if (i) return i;
      }
      return e.result;
    }, this.api = a, this.config = n, this.sessionCtx = r, this.messageCtx = h, this.sessionPollingIntervalSeconds = s, this.registerPolling();
  }
}
class H {
  constructor({
    config: a,
    api: n,
    storageCtx: r
  }) {
    var h;
    this.shouldCollectData = () => {
      var s;
      return !!(!((s = this.state.get().contact) != null && s.token) && this.config.collectUserData);
    }, this.autoCreateUnverifiedUserIfNotExists = async () => {
      var s, e, t, o, i, l, c, u, p, w, d, k, y, v;
      if (!((s = this.config.user) != null && s.token)) {
        if (this.config.collectUserData && !((t = (e = this.config.user) == null ? void 0 : e.data) != null && t.email)) {
          if ((o = this.config.extraDataCollectionFields) != null && o.length)
            return;
          const b = await ((i = this.storageCtx) == null ? void 0 : i.getContactToken());
          b && await this.setUnverifiedContact(b);
          return;
        }
        if (!((c = (l = this.config.user) == null ? void 0 : l.data) != null && c.email)) {
          const b = await ((u = this.storageCtx) == null ? void 0 : u.getContactToken());
          if (b) {
            await this.setUnverifiedContact(b);
            return;
          }
        }
        await this.createUnverifiedContact({
          email: (w = (p = this.config.user) == null ? void 0 : p.data) == null ? void 0 : w.email,
          non_verified_name: (k = (d = this.config.user) == null ? void 0 : d.data) == null ? void 0 : k.name,
          non_verified_custom_data: (v = (y = this.config.user) == null ? void 0 : y.data) == null ? void 0 : v.customData
        });
      }
    }, this.createUnverifiedContact = async (s, e) => {
      this.state.setPartial({ extraCollectedData: e });
      try {
        this.state.setPartial({
          isCreatingUnverifiedContact: !0,
          isErrorCreatingUnverifiedContact: !1
        });
        const { data: t } = await this.api.createUnverifiedContact(s);
        t != null && t.token ? await this.setUnverifiedContact(t.token) : this.state.setPartial({ isErrorCreatingUnverifiedContact: !0 });
      } finally {
        this.state.setPartial({ isCreatingUnverifiedContact: !1 });
      }
    }, this.setUnverifiedContact = async (s) => {
      var o, i, l, c;
      const e = await ((o = this.storageCtx) == null ? void 0 : o.getExternalContactId()), t = ((i = this.config.user) == null ? void 0 : i.externalId) || e || E();
      this.api.setAuthToken(s), await ((l = this.storageCtx) == null ? void 0 : l.setContactToken(s)), await ((c = this.storageCtx) == null ? void 0 : c.setExternalContactId(t)), this.state.setPartial({ contact: { token: s, externalId: t } });
    }, this.config = a, this.storageCtx = r, this.api = n, this.state = new S({
      contact: (h = a.user) != null && h.token ? {
        token: a.user.token,
        // Set optional externalId from config... not local storage
        externalId: a.user.externalId
      } : null,
      extraCollectedData: void 0,
      isCreatingUnverifiedContact: !1,
      isErrorCreatingUnverifiedContact: !1
    }), this.autoCreateUnverifiedUserIfNotExists();
  }
}
function C() {
  return E();
}
class q {
  constructor({
    config: a,
    api: n,
    sessionCtx: r,
    messageCtx: h
  }) {
    this.submitCsat = async (s) => {
      var l;
      const e = (l = this.sessionCtx.sessionState.get().session) == null ? void 0 : l.id;
      if (!e)
        return { data: null, error: "No session id found" };
      const t = C();
      this.messageCtx.state.setPartial({
        messages: [
          ...this.messageCtx.state.get().messages,
          {
            id: t,
            type: "SYSTEM",
            subtype: "csat_submitted",
            timestamp: (/* @__PURE__ */ new Date()).toISOString(),
            data: {
              payload: {
                score: s.score,
                feedback: s.feedback
              }
            }
          }
        ]
      });
      const { data: o, error: i } = await this.api.submitCsat({
        ...s,
        system_message_uuid: t,
        session_id: e
      });
      return { data: o, error: i };
    }, this.config = a, this.api = n, this.sessionCtx = r, this.messageCtx = h;
  }
}
class J {
  constructor({
    config: a,
    api: n,
    contactCtx: r,
    sessionsPollingIntervalSeconds: h
  }) {
    this.sessionsRefresher = new U(), this.sessionState = new S({
      session: null,
      isCreatingSession: !1,
      isResolvingSession: !1
    }), this.sessionsState = new S({
      data: [],
      cursor: void 0,
      isLastPage: !1,
      didStartInitialFetch: !1,
      /**
       * Initialize this as `true` so it always starts loading until the first fetch is done
       */
      isInitialFetchLoading: !0
    }), this.reset = async () => {
      this.sessionState.reset();
    }, this.registerSessionsRefresherWrapper = () => {
      var s;
      // If the widget config was initially provided with a contact token, no state change would be triggered, so we just fetch
      (s = this.contactCtx.state.get().contact) != null && s.token && !this.sessionsState.get().didStartInitialFetch ? this.registerSessionsRefresher() : this.contactCtx.state.subscribe(({ contact: e }) => {
        e != null && e.token && !this.sessionsState.get().didStartInitialFetch && this.registerSessionsRefresher();
      });
    }, this.registerSessionsRefresher = () => {
      this.sessionsRefresher.startPolling(async () => {
        this.sessionsState.get().didStartInitialFetch === !1 && this.sessionsState.setPartial({ didStartInitialFetch: !0 }), await this.refreshSessions(), this.sessionsState.get().isInitialFetchLoading === !0 && this.sessionsState.setPartial({ isInitialFetchLoading: !1 });
      }, this.sessionsPollingIntervalSeconds * 1e3);
    }, this.getParsedCustomData = () => Object.fromEntries(
      Object.entries(this.config.sessionCustomData || {}).map(
        ([s, e]) => {
          var t;
          return typeof e == "string" ? [s, e] : typeof e == "boolean" ? [s, e] : typeof e == "number" ? [s, e] : [s, ((t = L(() => JSON.stringify(e))) == null ? void 0 : t.data) || ""];
        }
      )
    ), this.createSession = async () => {
      var i;
      this.sessionState.setPartial({ session: null, isCreatingSession: !0 });
      const s = (i = this.contactCtx.state.get().contact) == null ? void 0 : i.externalId, e = {
        ...this.getParsedCustomData(),
        ...s ? { external_id: s } : {}
      }, { data: t, error: o } = await this.api.createSession({
        customData: Object.keys(e).length > 0 ? e : void 0
      });
      return t ? (this.sessionState.setPartial({ session: t, isCreatingSession: !1 }), t) : (this.sessionState.setPartial({ isCreatingSession: !1 }), console.error("Failed to create session:", o), null);
    }, this.loadMoreSessions = async () => {
      if (this.sessionsState.get().isLastPage) return;
      const { data: s } = await this.getSessions({
        cursor: this.sessionsState.get().cursor
      });
      if (s) {
        const t = [...this.sessionsState.get().data, ...s.items].filter(
          (o, i, l) => i === l.findIndex((c) => o.id === c.id)
        );
        this.sessionsState.setPartial({
          data: t,
          cursor: s.next || void 0,
          isLastPage: s.next === null
        });
      }
    }, this.getSessions = async ({ cursor: s }) => {
      var t, o;
      if (!((t = this.contactCtx.state.get().contact) != null && t.token)) return { data: null };
      const e = (o = this.contactCtx.state.get().contact) == null ? void 0 : o.externalId;
      return await this.api.getSessions({
        cursor: s,
        filters: e ? {
          external_id: e
        } : {}
      });
    }, this.setSessions = (s) => {
      const e = [...s, ...this.sessionsState.get().data].filter(
        (t, o, i) => o === i.findIndex((l) => t.id === l.id)
      );
      this.sessionsState.setPartial({ data: e });
    }, this.refreshSessions = async () => {
      const { data: s } = await this.getSessions({ cursor: void 0 });
      s && this.setSessions(s.items);
    }, this.resolveSession = async () => {
      const s = this.sessionState.get().session;
      if (!s || !s.isOpened)
        return { success: !1, error: "Session is not opened" };
      this.sessionState.setPartial({ isResolvingSession: !0 });
      const { data: e, error: t } = await this.api.resolveSession({
        session_id: s.id
      });
      return e ? (this.sessionState.setPartial({ session: e, isResolvingSession: !1 }), { success: !0, data: e }) : (this.sessionState.setPartial({ isResolvingSession: !1 }), { success: !1, error: t });
    }, this.createStateCheckpoint = async (s) => {
      var i;
      const e = (i = this.sessionState.get().session) == null ? void 0 : i.id;
      if (!e) return;
      const { data: t, error: o } = await this.api.createStateCheckpoint({
        session_id: e,
        payload: s
      });
      return t != null && t.success ? { success: !0 } : { success: !1 };
    }, this.config = a, this.api = n, this.contactCtx = r, this.sessionsPollingIntervalSeconds = h, this.registerSessionsRefresherWrapper();
  }
}
class Y {
  constructor({
    config: a,
    api: n,
    sessionCtx: r,
    contactCtx: h
  }) {
    this.state = new S({
      messages: [],
      isSendingMessage: !1,
      isSendingMessageToAI: !1,
      lastAIResMightSolveUserIssue: !1,
      isInitialFetchLoading: !1
    }), this.sendMessageAbortController = new AbortController(), this.reset = () => {
      this.sendMessageAbortController.abort("Resetting chat"), this.state.reset();
    }, this.sendMessage = async (s) => {
      var e, t, o, i, l, c, u, p, w;
      try {
        if (!s.content.trim() && (!s.attachments || s.attachments.length === 0)) {
          console.warn(
            "Cannot send an empty message of no content or attachments"
          );
          return;
        }
        const d = this.sessionCtx.sessionState.get().session, y = (d == null ? void 0 : d.assignee.kind) === "ai", v = this.state.get().isSendingMessageToAI, b = this.state.get().messages.at(-1);
        if (v || // If last message is from user, then bot response did not arrive yet
        y && (b == null ? void 0 : b.type) === "USER") {
          console.warn("Cannot send messages while awaiting AI response");
          return;
        }
        this.sendMessageAbortController = new AbortController(), this.state.setPartial({
          lastAIResMightSolveUserIssue: !1,
          isSendingMessage: !0,
          isSendingMessageToAI: !!y || !d
        });
        const P = this.state.get().messages, z = !((e = this.sessionCtx.sessionState.get().session) != null && e.id) && P.length === 0 && ((t = this.config.advancedInitialMessages) == null ? void 0 : t.some((g) => g.persistent)), A = z ? (this.config.advancedInitialMessages || []).filter((g) => g.persistent).map(
          (g) => ({
            id: C(),
            component: "bot_message",
            type: "AI",
            timestamp: (/* @__PURE__ */ new Date()).toISOString(),
            data: {
              message: g.message
            },
            agent: this.config.bot ? { ...this.config.bot, isAi: !0, id: null } : void 0
          })
        ) : [], I = this.toUserMessage(
          s.content.trim(),
          s.attachments || void 0
        );
        if (this.state.setPartial({
          messages: [
            ...A,
            ...P,
            I
          ]
        }), !((o = this.sessionCtx.sessionState.get().session) != null && o.id)) {
          if (!await this.sessionCtx.createSession()) {
            console.error("Failed to create session");
            return;
          }
          this.sessionCtx.refreshSessions();
        }
        const T = (i = this.sessionCtx.sessionState.get().session) == null ? void 0 : i.id;
        if (!T) return;
        const { data: m } = await this.api.sendMessage(
          {
            uuid: I.id,
            bot_token: this.config.token,
            headers: this.config.headers,
            query_params: this.config.queryParams,
            body_properties: this.config.bodyProperties,
            session_id: T,
            content: I.content,
            attachments: s.attachments,
            clientContext: this.config.context,
            custom_data: {
              ...this.config.messageCustomData || {},
              ...s.customData || {}
            },
            language: this.config.language,
            exit_mode_prompt: s.exitModePrompt,
            initial_messages: z ? A.map((g) => ({
              uuid: g.id,
              content: g.data.message
            })) : void 0
          },
          this.sendMessageAbortController.signal
        );
        if (m != null && m.success) {
          const g = this.toBotMessage(m);
          if (g) {
            const x = this.state.get().messages;
            if (!!x.some(
              (R) => R.id === g.id
            )) {
              this.state.setPartial({
                lastAIResMightSolveUserIssue: ((l = m.autopilotResponse) == null ? void 0 : l.mightSolveUserIssue) || ((c = m.uiResponse) == null ? void 0 : c.mightSolveUserIssue)
              });
              return;
            }
            this.state.setPartial({
              messages: [...x, g],
              lastAIResMightSolveUserIssue: ((u = m.autopilotResponse) == null ? void 0 : u.mightSolveUserIssue) || ((p = m.uiResponse) == null ? void 0 : p.mightSolveUserIssue)
            });
          }
          m.session && this.sessionCtx.sessionState.setPartial({ session: m.session });
        } else {
          const g = this.toBotErrorMessage(
            ((w = m == null ? void 0 : m.error) == null ? void 0 : w.message) || "Something went wrong. Please refresh the page or try again."
          ), x = this.state.get().messages;
          this.state.setPartial({
            messages: [...x, g]
          });
        }
      } catch (d) {
        this.sendMessageAbortController.signal.aborted || console.error("Failed to send message:", d);
      } finally {
        this.state.setPartial({
          isSendingMessage: !1,
          isSendingMessageToAI: !1
        });
      }
    }, this.toUserMessage = (s, e) => {
      const t = (() => {
        const o = this.contactCtx.state.get().extraCollectedData;
        return this.state.get().messages.length === 0 && o && Object.keys(o).length > 0 ? `${Object.entries(o).filter(([l, c]) => !!c).map(([l, c]) => `${l}: ${c}`).join(` 
`)} 

${s}` : s;
      })();
      return {
        id: C(),
        type: "USER",
        content: t,
        deliveredAt: (/* @__PURE__ */ new Date()).toISOString(),
        attachments: e,
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
    }, this.toBotMessage = (s) => {
      var e;
      return s.success && s.autopilotResponse ? {
        type: "AI",
        id: s.autopilotResponse.id || C(),
        timestamp: (/* @__PURE__ */ new Date()).toISOString(),
        component: "bot_message",
        agent: this.config.bot ? {
          name: this.config.bot.name || "",
          isAi: !0,
          // Do not set avatarUrl here... let it be taken from the config at render time
          avatarUrl: null,
          avatar: null,
          id: null
        } : void 0,
        data: {
          message: s.autopilotResponse.value.content,
          action: (e = s.uiResponse) != null && e.value.name ? {
            name: s.uiResponse.value.name,
            data: s.uiResponse.value.request_response
          } : void 0
        }
      } : null;
    }, this.toBotErrorMessage = (s) => ({
      type: "AI",
      id: C(),
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      component: "bot_message",
      data: {
        message: s,
        variant: "error",
        action: void 0
      }
    }), this.config = a, this.api = n, this.sessionCtx = r, this.contactCtx = h;
  }
}
class $ {
  constructor({
    config: a,
    contactCtx: n,
    sessionCtx: r,
    resetChat: h
  }) {
    var s;
    this.registerRoutingListener = () => {
      this.contactCtx.state.subscribe(({ contact: e }) => {
        var t;
        e != null && e.token && this.state.get().screen === "welcome" && this.state.setPartial({
          screen: (t = this.config.router) != null && t.chatScreenOnly ? "chat" : "sessions"
        });
      }), this.sessionCtx.sessionsState.subscribe(
        ({ isInitialFetchLoading: e, data: t }) => {
          var o, i, l, c;
          if ((o = this.config.router) != null && o.chatScreenOnly && // Do not route to a chat if we are currently inside one already
          // This also applies to newly created sessions; the new session will be in `sessionState` before it is refreshed and included in `sessionsState`
          !((i = this.sessionCtx.sessionState.get().session) != null && i.id)) {
            const u = (l = t.find((p) => p.isOpened)) == null ? void 0 : l.id;
            return u ? this.toChatScreen(u) : void 0;
          }
          t.length || ((c = this.config.router) == null ? void 0 : c.goToChatIfNoSessions) !== !1 && !e && this.state.get().screen !== "chat" && this.toChatScreen();
        }
      );
    }, this.toSessionsScreen = () => {
      this.resetChat(), this.state.setPartial({ screen: "sessions" });
    }, this.toChatScreen = (e) => {
      if (this.resetChat(), e) {
        const t = this.sessionCtx.sessionsState.get().data.find((o) => o.id === e);
        if (!t) return;
        this.sessionCtx.sessionState.setPartial({ session: t });
      }
      this.state.setPartial({ screen: "chat" });
    }, this.config = a, this.contactCtx = n, this.sessionCtx = r, this.resetChat = h, this.state = new S({
      screen: this.contactCtx.shouldCollectData() ? "welcome" : (s = this.config.router) != null && s.chatScreenOnly ? "chat" : "sessions"
    }), this.registerRoutingListener();
  }
}
class G {
  constructor({
    storage: a,
    config: n
  }) {
    this.KEYS = {
      contactToken: (r) => `opencx-widget:org-token-${r}:contact-token`,
      externalContactId: (r) => `opencx-widget:org-token-${r}:external-contact-id`
    }, this.setContactToken = async (r) => {
      await this.storage.set(this.KEYS.contactToken(this.config.token), r);
    }, this.getContactToken = async () => this.storage.get(this.KEYS.contactToken(this.config.token)), this.setExternalContactId = async (r) => {
      await this.storage.set(this.KEYS.externalContactId(this.config.token), r);
    }, this.getExternalContactId = async () => this.storage.get(this.KEYS.externalContactId(this.config.token)), this.storage = a, this.config = n;
  }
}
const f = class f {
  constructor({
    config: a,
    storage: n,
    modes: r,
    org: h
  }) {
    if (this.modes = [], this.resetChat = () => {
      this.sessionCtx.reset(), this.messageCtx.reset();
    }, !f.pollingIntervalsSeconds)
      throw Error(
        "Widget polling values are not defined, did you call WidgetCtx.initialize()"
      );
    this.config = a, this.org = h, this.api = new j({ config: a }), this.storageCtx = n ? new G({ storage: n, config: a }) : void 0, this.modes = r, this.contactCtx = new H({
      api: this.api,
      config: this.config,
      storageCtx: this.storageCtx
    }), this.sessionCtx = new J({
      config: this.config,
      api: this.api,
      contactCtx: this.contactCtx,
      sessionsPollingIntervalSeconds: f.pollingIntervalsSeconds.sessions
    }), this.messageCtx = new Y({
      config: this.config,
      api: this.api,
      sessionCtx: this.sessionCtx,
      contactCtx: this.contactCtx
    }), this.csatCtx = new q({
      config: this.config,
      api: this.api,
      sessionCtx: this.sessionCtx,
      messageCtx: this.messageCtx
    }), this.activeSessionPollingCtx = new K({
      api: this.api,
      config: this.config,
      sessionCtx: this.sessionCtx,
      messageCtx: this.messageCtx,
      sessionPollingIntervalSeconds: f.pollingIntervalsSeconds.session
    }), this.routerCtx = new $({
      config: this.config,
      contactCtx: this.contactCtx,
      sessionCtx: this.sessionCtx,
      resetChat: this.resetChat
    });
  }
};
f.pollingIntervalsSeconds = null, f.initialize = async ({
  config: a,
  storage: n
}) => {
  var h, s, e;
  const r = await new j({
    config: a
  }).getExternalWidgetConfig();
  if (!r.data)
    throw new Error("Failed to fetch widget config");
  return f.pollingIntervalsSeconds = {
    session: ((h = r.data) == null ? void 0 : h.sessionPollingIntervalSeconds) || 10,
    sessions: ((s = r.data) == null ? void 0 : s.sessionsPollingIntervalSeconds) || 60
  }, new f({
    config: a,
    storage: n,
    modes: ((e = r.data) == null ? void 0 : e.modes) || [],
    org: {
      id: r.data.org.id,
      name: r.data.org.name
    }
  });
};
let M = f;
const W = {
  write_a_message_placeholder: "اكتب رسالة...",
  your_issue_has_been_resolved: "تم حل مشكلتك!",
  new_conversation: "محادثة جديدة",
  welcome_screen_title: "مرحبًا بك في دردشة الدعم الخاصة بنا",
  welcome_screen_description: "نحن هنا للمساعدة! ابدأ محادثة وسنرد عليك في أقرب وقت ممكن.",
  your_name_placeholder: "اسمك",
  your_email_placeholder: "عنوان بريدك الإلكتروني",
  start_chat_button: "تحدث إلى الدعم",
  start_chat_button_loading: "جاري الاتصال...",
  i_need_more_help: "أحتاج المزيد من المساعدة",
  this_was_helpful: "كان هذا مفيدًا",
  optional: "اختياري",
  no_conversations_yet: "لا يوجد محادثات",
  back_to_conversations: "العودة إلى المحادثات",
  closed_conversations: "المحادثات المغلقة"
}, Z = {
  write_a_message_placeholder: "একটি বার্তা লিখুন...",
  your_issue_has_been_resolved: "আপনার সমস্যা সমাধান হয়েছে!",
  new_conversation: "নতুন কথোপকথন",
  welcome_screen_title: "আমাদের সাপোর্ট চ্যাটে স্বাগতম",
  welcome_screen_description: "আমরা সাহায্য করতে এখানে আছি! একটি কথোপকথন শুরু করুন এবং আমরা যত তাড়াতাড়ি সম্ভব আপনার কাছে ফিরে আসব।",
  your_name_placeholder: "আপনার নাম",
  your_email_placeholder: "আপনার ইমেইল ঠিকানা",
  start_chat_button: "সাপোর্টের সাথে কথা বলুন",
  start_chat_button_loading: "সংযোগ হচ্ছে...",
  i_need_more_help: "আমার আরও সাহায্য দরকার",
  this_was_helpful: "এটি সহায়ক ছিল",
  optional: "ঐচ্ছিক",
  no_conversations_yet: "এখনো কোনো কথোপকথন নেই",
  back_to_conversations: "কথোপকথনে ফিরে যান",
  closed_conversations: "বন্ধ কথোপকথন"
}, X = {
  write_a_message_placeholder: "Напишете съобщение...",
  your_issue_has_been_resolved: "Вашият проблем е разрешен!",
  new_conversation: "Нов разговор",
  welcome_screen_title: "Добре дошли в нашия чат за поддръжка",
  welcome_screen_description: "Тук сме, за да помогнем! Започнете разговор и ще ви отговорим възможно най-скоро.",
  your_name_placeholder: "Вашето име",
  your_email_placeholder: "Вашият имейл адрес",
  start_chat_button: "Свържете се с поддръжка",
  start_chat_button_loading: "Свързване...",
  i_need_more_help: "Имам нужда от повече помощ",
  this_was_helpful: "Това беше полезно",
  optional: "По избор",
  no_conversations_yet: "Все още няма разговори",
  back_to_conversations: "Назад към разговорите",
  closed_conversations: "Затворени разговори"
}, Q = {
  write_a_message_placeholder: "Napište zprávu...",
  your_issue_has_been_resolved: "Váš problém byl vyřešen!",
  new_conversation: "Nová konverzace",
  welcome_screen_title: "Vítejte v našem chatu podpory",
  welcome_screen_description: "Jsme tu, abychom vám pomohli! Zahajte konverzaci a ozveme se vám co nejdříve.",
  your_name_placeholder: "Vaše jméno",
  your_email_placeholder: "Vaše e-mailová adresa",
  start_chat_button: "Kontaktovat podporu",
  start_chat_button_loading: "Připojování...",
  i_need_more_help: "Potřebuji další pomoc",
  this_was_helpful: "Toto bylo užitečné",
  optional: "Volitelné",
  no_conversations_yet: "Zatím žádné konverzace",
  back_to_conversations: "Zpět na konverzace",
  closed_conversations: "Uzavřené konverzace"
}, ee = {
  write_a_message_placeholder: "Skriv en besked...",
  your_issue_has_been_resolved: "Dit problem er løst!",
  new_conversation: "Ny samtale",
  welcome_screen_title: "Velkommen til vores support chat",
  welcome_screen_description: "Vi er her for at hjælpe! Start en samtale, og vi vender tilbage til dig så hurtigt som muligt.",
  your_name_placeholder: "Dit navn",
  your_email_placeholder: "Din e-mailadresse",
  start_chat_button: "Tal med support",
  start_chat_button_loading: "Forbinder...",
  i_need_more_help: "Jeg har brug for mere hjælp",
  this_was_helpful: "Dette var nyttigt",
  optional: "Valgfrit",
  no_conversations_yet: "Ingen samtaler endnu",
  back_to_conversations: "Tilbage til samtaler",
  closed_conversations: "Lukkede samtaler"
}, te = {
  write_a_message_placeholder: "Γράψτε ένα μήνυμα...",
  your_issue_has_been_resolved: "Το πρόβλημά σας επιλύθηκε!",
  new_conversation: "Νέα συνομιλία",
  welcome_screen_title: "Καλώς ήρθατε στη συνομιλία υποστήριξης",
  welcome_screen_description: "Είμαστε εδώ για να βοηθήσουμε! Ξεκινήστε μια συνομιλία και θα σας απαντήσουμε το συντομότερο δυνατό.",
  your_name_placeholder: "Το όνομά σας",
  your_email_placeholder: "Η διεύθυνση email σας",
  start_chat_button: "Επικοινωνία με την υποστήριξη",
  start_chat_button_loading: "Σύνδεση...",
  i_need_more_help: "Χρειάζομαι περισσότερη βοήθεια",
  this_was_helpful: "Αυτό ήταν χρήσιμο",
  optional: "Προαιρετικό",
  no_conversations_yet: "Δεν υπάρχουν συνομιλίες ακόμα",
  back_to_conversations: "Πίσω στις συνομιλίες",
  closed_conversations: "Κλειστές συνομιλίες"
}, se = {
  write_a_message_placeholder: "Nachricht schreiben...",
  your_issue_has_been_resolved: "Ihr Problem wurde gelöst!",
  new_conversation: "Neue Konversation",
  welcome_screen_title: "Willkommen in unserem Support-Chat",
  welcome_screen_description: "Wir sind hier, um zu helfen! Beginnen Sie ein Gesprách und wir werden so schnell wie mogelijk antworten.",
  your_name_placeholder: "Ihr Name",
  your_email_placeholder: "Ihre E-Mail-Adresse",
  start_chat_button: "Mit dem Support sprechen",
  start_chat_button_loading: "Verbindung wird hergestellt...",
  i_need_more_help: "Ich brauche weitere Hilfe",
  this_was_helpful: "Dies war hilfreich",
  optional: "Optional",
  no_conversations_yet: "noch keine Gespräche",
  back_to_conversations: "Zurück zur Konversationen",
  closed_conversations: "Geschlossene Konversationen"
}, ae = {
  write_a_message_placeholder: "Write a message...",
  your_issue_has_been_resolved: "Your issue has been resolved!",
  new_conversation: "New conversation",
  welcome_screen_title: "Welcome to our support chat",
  welcome_screen_description: "We're here to help! Start a conversation and we'll get back to you as soon as possible.",
  your_name_placeholder: "Your name",
  your_email_placeholder: "Your email address",
  start_chat_button: "Talk to support",
  start_chat_button_loading: "Connecting...",
  i_need_more_help: "I need more help",
  this_was_helpful: "This was helpful",
  optional: "Optional",
  no_conversations_yet: "No conversations yet",
  back_to_conversations: "Back to conversations",
  closed_conversations: "Closed conversations"
}, oe = {
  write_a_message_placeholder: "Escribe un mensaje...",
  your_issue_has_been_resolved: "¡Tu problema fue resuelto!",
  new_conversation: "Nueva conversación",
  welcome_screen_title: "Bienvenido a nuestro chat de soporte",
  welcome_screen_description: "¡Estamos aquí para ayudarte! Inicia una conversación y responderemos lo antes posible.",
  your_name_placeholder: "Tu nombre",
  your_email_placeholder: "Tu correo electrónico",
  start_chat_button: "Hablar con soporte",
  start_chat_button_loading: "Conectando...",
  i_need_more_help: "Necesito más ayuda",
  this_was_helpful: "Esto fue útil",
  optional: "Opcional",
  no_conversations_yet: "Sin conversaciones aún",
  back_to_conversations: "Volver a conversaciones",
  closed_conversations: "Conversaciones cerradas"
}, ne = {
  write_a_message_placeholder: "Magsulat ng mensahe...",
  your_issue_has_been_resolved: "Nalutas na ang iyong isyu!",
  new_conversation: "Bagong usapan",
  welcome_screen_title: "Maligayang pagdating sa aming support chat",
  welcome_screen_description: "Narito kami upang tumulong! Magsimula ng usapan at babalikan ka namin sa lalong madaling panahon.",
  your_name_placeholder: "Iyong pangalan",
  your_email_placeholder: "Iyong email address",
  start_chat_button: "Makipag-usap sa support",
  start_chat_button_loading: "Kumokonekta...",
  i_need_more_help: "Kailangan ko pa ng tulong",
  this_was_helpful: "Nakatulong ito",
  optional: "Opsyonal",
  no_conversations_yet: "Wala pang mga usapan",
  back_to_conversations: "Bumalik sa mga usapan",
  closed_conversations: "Mga saradong usapan"
}, ie = {
  write_a_message_placeholder: "Kirjoita viesti...",
  your_issue_has_been_resolved: "Ongelmasi on ratkaistu!",
  new_conversation: "Uusi keskustelu",
  welcome_screen_title: "Tervetuloa tukichattiin",
  welcome_screen_description: "Olemme täällä auttamassa! Aloita keskustelu ja palaamme sinulle mahdollisimman pian.",
  your_name_placeholder: "Nimesi",
  your_email_placeholder: "Sähköpostiosoitteesi",
  start_chat_button: "Keskustele tuen kanssa",
  start_chat_button_loading: "Yhdistetään...",
  i_need_more_help: "Tarvitsen lisää apua",
  this_was_helpful: "Tämä oli hyödyllistä",
  optional: "Valinnainen",
  no_conversations_yet: "Ei vielä keskusteluja",
  back_to_conversations: "Takaisin keskusteluihin",
  closed_conversations: "Suljetut keskustelut"
}, re = {
  write_a_message_placeholder: "Écrivez un message...",
  your_issue_has_been_resolved: "Votre problème a été résolu !",
  new_conversation: "Nouvelle conversation",
  welcome_screen_title: "Bienvenue dans notre chat de support",
  welcome_screen_description: "Nous sommes là pour vous aider ! Commencez une conversation et nous vous répondrons dès que possible.",
  your_name_placeholder: "Votre nom",
  your_email_placeholder: "Votre adresse e-mail",
  start_chat_button: "Parler au support",
  start_chat_button_loading: "Connexion...",
  i_need_more_help: "Je besoin d'aide plus",
  this_was_helpful: "C'était utile",
  optional: "Optionnel",
  no_conversations_yet: "Aucune conversation pour le moment",
  back_to_conversations: "Retour aux conversations",
  closed_conversations: "Conversations fermées"
}, le = {
  write_a_message_placeholder: "एक संदेश लिखें...",
  your_issue_has_been_resolved: "आपकी समस्या हल हो गई है!",
  new_conversation: "नई बातचीत",
  welcome_screen_title: "हमारी सहायता चैट में आपका स्वागत है",
  welcome_screen_description: "हम मदद के लिए यहाँ हैं! बातचीत शुरू करें और हम जल्द से जल्द आपसे संपर्क करेंगे।",
  your_name_placeholder: "आपका नाम",
  your_email_placeholder: "आपका ईमेल पता",
  start_chat_button: "सहायता से बात करें",
  start_chat_button_loading: "कनेक्ट हो रहा है...",
  i_need_more_help: "मुझे और मदद चाहिए",
  this_was_helpful: "यह मददगार था",
  optional: "वैकल्पिक",
  no_conversations_yet: "अभी तक कोई बातचीत नहीं",
  back_to_conversations: "बातचीत पर वापस जाएं",
  closed_conversations: "बंद बातचीत"
}, ce = {
  write_a_message_placeholder: "Scrivi un messaggio...",
  your_issue_has_been_resolved: "Il tuo problema è stato risolto!",
  new_conversation: "Nuova conversazione",
  welcome_screen_title: "Benvenuto nella nostra chat di supporto",
  welcome_screen_description: "Siamo qui per aiutarti! Inizia una conversazione e ti risponderemo il prima possibile.",
  your_name_placeholder: "Il tuo nome",
  your_email_placeholder: "Il tuo indirizzo email",
  start_chat_button: "Parla con il supporto",
  start_chat_button_loading: "Connessione in corso...",
  i_need_more_help: "Ho bisogno di ulteriore aiuto",
  this_was_helpful: "Questo è stato utile",
  optional: "Opzionale",
  no_conversations_yet: "Nessuna conversazione ancora",
  back_to_conversations: "Torna alle conversazioni",
  closed_conversations: "Conversazioni chiuse"
}, _e = {
  write_a_message_placeholder: "メッセージを入力...",
  your_issue_has_been_resolved: "問題が解決しました！",
  new_conversation: "新しい会話",
  welcome_screen_title: "サポートチャットへようこそ",
  welcome_screen_description: "お手伝いいたします！会話を開始していただければ、できるだけ早くご連絡いたします。",
  your_name_placeholder: "お名前",
  your_email_placeholder: "メールアドレス",
  start_chat_button: "サポートに相談",
  start_chat_button_loading: "接続中...",
  i_need_more_help: "さらにサポートが必要です",
  this_was_helpful: "役に立ちました",
  optional: "任意",
  no_conversations_yet: "まだ会話がありません",
  back_to_conversations: "会話一覧に戻る",
  closed_conversations: "終了した会話"
}, he = {
  write_a_message_placeholder: "메시지를 입력하세요...",
  your_issue_has_been_resolved: "문제가 해결되었습니다!",
  new_conversation: "새 대화",
  welcome_screen_title: "고객 지원 채팅에 오신 것을 환영합니다",
  welcome_screen_description: "도움을 드리기 위해 여기 있습니다! 대화를 시작해 주시면 가능한 한 빨리 연락드리겠습니다.",
  your_name_placeholder: "이름",
  your_email_placeholder: "이메일 주소",
  start_chat_button: "상담원과 대화",
  start_chat_button_loading: "연결 중...",
  i_need_more_help: "추가 도움이 필요합니다",
  this_was_helpful: "도움이 되었습니다",
  optional: "선택 사항",
  no_conversations_yet: "아직 대화가 없습니다",
  back_to_conversations: "대화 목록으로 돌아가기",
  closed_conversations: "종료된 대화"
}, ue = {
  write_a_message_placeholder: "Schrijf een bericht...",
  your_issue_has_been_resolved: "Uw probleem is opgelost!",
  new_conversation: "Nieuw gesprek",
  welcome_screen_title: "Welkom bij onze supportchat",
  welcome_screen_description: "We zijn hier om te helpen! Begin een gesprek en we nemen zo snel mogelijk contact met u op.",
  your_name_placeholder: "Uw naam",
  your_email_placeholder: "Uw e-mailadres",
  start_chat_button: "Praat met ondersteuning",
  start_chat_button_loading: "Verbinding maken...",
  i_need_more_help: "Ik heb nog meer hulp nodig",
  this_was_helpful: "Mijn vraag is opgelost",
  optional: "Optioneel",
  no_conversations_yet: "Nog geen gesprekken",
  back_to_conversations: "Terug naar gesprekken",
  closed_conversations: "Afgesloten gesprekken"
}, de = {
  write_a_message_placeholder: "Skriv en melding...",
  your_issue_has_been_resolved: "Problemet ditt er løst!",
  new_conversation: "Ny samtale",
  welcome_screen_title: "Velkommen til vår kundestøtte-chat",
  welcome_screen_description: "Vi er her for å hjelpe! Start en samtale så kommer vi tilbake til deg så snart som mulig.",
  your_name_placeholder: "Ditt navn",
  your_email_placeholder: "Din e-postadresse",
  start_chat_button: "Snakk med kundestøtte",
  start_chat_button_loading: "Kobler til...",
  i_need_more_help: "Jeg trenger mer hjelp",
  this_was_helpful: "Dette var nyttig",
  optional: "Valgfritt",
  no_conversations_yet: "Ingen samtaler ennå",
  back_to_conversations: "Tilbake til samtaler",
  closed_conversations: "Lukkede samtaler"
}, ge = {
  write_a_message_placeholder: "Napisz wiadomość...",
  your_issue_has_been_resolved: "Twój problem został rozwiązany!",
  new_conversation: "Nowa rozmowa",
  welcome_screen_title: "Witamy w naszym czacie wsparcia",
  welcome_screen_description: "Jesteśmy tutaj, aby pomóc! Rozpocznij rozmowę, a odpowiemy jak najszybciej.",
  your_name_placeholder: "Twoje imię",
  your_email_placeholder: "Twój adres email",
  start_chat_button: "Porozmawiaj ze wsparciem",
  start_chat_button_loading: "Łączenie...",
  i_need_more_help: "Potrzebuję więcej pomocy",
  this_was_helpful: "To było pomocne",
  optional: "Opcjonalne",
  no_conversations_yet: "Jeszcze brak rozmów",
  back_to_conversations: "Powrót do rozmów",
  closed_conversations: "Zamknięte rozmowy"
}, me = {
  write_a_message_placeholder: "Escreva uma mensagem...",
  your_issue_has_been_resolved: "Seu problema foi resolvido!",
  new_conversation: "Nova conversa",
  welcome_screen_title: "Bem-vindo ao nosso chat de suporte",
  welcome_screen_description: "Estamos aqui para ajudar! Inicie uma conversa e responderemos o mais rápido possível.",
  your_name_placeholder: "Seu nome",
  your_email_placeholder: "Seu endereço de email",
  start_chat_button: "Falar com o suporte",
  start_chat_button_loading: "Conectando...",
  i_need_more_help: "preciso de mais ajuda",
  this_was_helpful: "Isso foi útil",
  optional: "Opcional",
  no_conversations_yet: "Nenhuma conversa ainda",
  back_to_conversations: "Voltar para conversas",
  closed_conversations: "Conversas fechadas"
}, pe = {
  write_a_message_placeholder: "Scrie un mesaj...",
  your_issue_has_been_resolved: "Problema ta a fost rezolvată!",
  new_conversation: "Conversație nouă",
  welcome_screen_title: "Bine ai venit la chat-ul nostru de suport",
  welcome_screen_description: "Suntem aici să te ajutăm! Începe o conversație și îți vom răspunde cât mai curând posibil.",
  your_name_placeholder: "Numele tău",
  your_email_placeholder: "Adresa ta de email",
  start_chat_button: "Vorbește cu suportul",
  start_chat_button_loading: "Se conectează...",
  i_need_more_help: "Am nevoie de mai mult ajutor",
  this_was_helpful: "Acest lucru a fost util",
  optional: "Opțional",
  no_conversations_yet: "Încă nu există conversații",
  back_to_conversations: "Înapoi la conversații",
  closed_conversations: "Conversații închise"
}, ve = {
  write_a_message_placeholder: "Skriv ett meddelande...",
  your_issue_has_been_resolved: "Ditt problem har lösts!",
  new_conversation: "Ny konversation",
  welcome_screen_title: "Välkommen till vår supportchatt",
  welcome_screen_description: "Vi är här för att hjälpa! Starta en konversation så återkommer vi till dig så snart som möjligt.",
  your_name_placeholder: "Ditt namn",
  your_email_placeholder: "Din e-postadress",
  start_chat_button: "Prata med support",
  start_chat_button_loading: "Ansluter...",
  i_need_more_help: "Jag behöver mer hjälp",
  this_was_helpful: "Detta var användbart",
  optional: "Frivilligt",
  no_conversations_yet: "Inga konversationer ännu",
  back_to_conversations: "Tillbaka till konversationer",
  closed_conversations: "Stängda konversationer"
}, be = {
  write_a_message_placeholder: "Напишите сообщение...",
  your_issue_has_been_resolved: "Ваша проблема решена!",
  new_conversation: "Новый разговор",
  welcome_screen_title: "Добро пожаловать в чат поддержки",
  welcome_screen_description: "Мы здесь, чтобы помочь! Начните разговор, и мы ответим вам как можно скорее.",
  your_name_placeholder: "Ваше имя",
  your_email_placeholder: "Ваш адрес электронной почты",
  start_chat_button: "Связаться с поддержкой",
  start_chat_button_loading: "Подключение...",
  i_need_more_help: "Мне нужна дополнительная помощь",
  this_was_helpful: "Это было полезно",
  optional: "Необязательно",
  no_conversations_yet: "Пока нет разговоров",
  back_to_conversations: "Назад к разговорам",
  closed_conversations: "Закрытые разговоры"
}, fe = {
  write_a_message_placeholder: "เขียนข้อความ...",
  your_issue_has_been_resolved: "ปัญหาของคุณได้รับการแก้ไขแล้ว!",
  new_conversation: "การสนทนาใหม่",
  welcome_screen_title: "ยินดีต้อนรับสู่แชทสนับสนุนของเรา",
  welcome_screen_description: "เราพร้อมช่วยเหลือคุณ! เริ่มการสนทนาและเราจะติดต่อกลับโดยเร็วที่สุด",
  your_name_placeholder: "ชื่อของคุณ",
  your_email_placeholder: "ที่อยู่อีเมลของคุณ",
  start_chat_button: "พูดคุยกับฝ่ายสนับสนุน",
  start_chat_button_loading: "กำลังเชื่อมต่อ...",
  i_need_more_help: "ฉันต้องการความช่วยเหลือเพิ่มเติม",
  this_was_helpful: "สิ่งนี้เป็นประโยชน์",
  optional: "ไม่บังคับ",
  no_conversations_yet: "ยังไม่มีการสนทนา",
  back_to_conversations: "กลับไปที่การสนทนา",
  closed_conversations: "การสนทนาที่ปิดแล้ว"
}, we = {
  write_a_message_placeholder: "Bir mesaj yazın...",
  your_issue_has_been_resolved: "Sorununuz çözüldü!",
  new_conversation: "Yeni konuşma",
  welcome_screen_title: "Destek sohbetimize hoş geldiniz",
  welcome_screen_description: "Yardım etmek için buradayız! Bir konuşma başlatın, en kısa sürede size geri döneceğiz.",
  your_name_placeholder: "Adınız",
  your_email_placeholder: "E-posta adresiniz",
  start_chat_button: "Destekle konuş",
  start_chat_button_loading: "Bağlanıyor...",
  i_need_more_help: "Daha fazla yardıma ihtiyacım var",
  this_was_helpful: "Bu yardımcı oldu",
  optional: "İsteğe bağlı",
  no_conversations_yet: "Henüz konuşma yok",
  back_to_conversations: "Konuşmalara geri dön",
  closed_conversations: "Kapatılan konuşmalar"
}, ye = {
  write_a_message_placeholder: "پیغام لکھیں...",
  your_issue_has_been_resolved: "آپ کا مسئلہ حل ہو گیا ہے!",
  new_conversation: "نئی گفتگو",
  welcome_screen_title: "ہماری سپورٹ چیٹ میں خوش آمدید",
  welcome_screen_description: "ہم مدد کے لیے حاضر ہیں! گفتگو شروع کریں اور ہم جلد از جلد آپ سے رابطہ کریں گے۔",
  your_name_placeholder: "آپ کا نام",
  your_email_placeholder: "آپ کا ای میل پتہ",
  start_chat_button: "سپورٹ سے بات کریں",
  start_chat_button_loading: "جڑ رہا ہے...",
  i_need_more_help: "مجھے مزید مدد چاہیے",
  this_was_helpful: "یہ مددگار تھا",
  optional: "اختیاری",
  no_conversations_yet: "ابھی تک کوئی گفتگو نہیں",
  back_to_conversations: "گفتگو پر واپس جائیں",
  closed_conversations: "بند گفتگو"
}, ke = {
  write_a_message_placeholder: "Viết tin nhắn...",
  your_issue_has_been_resolved: "Vấn đề của bạn đã được giải quyết!",
  new_conversation: "Cuộc trò chuyện mới",
  welcome_screen_title: "Chào mừng đến với hỗ trợ trò chuyện của chúng tôi",
  welcome_screen_description: "Chúng tôi ở đây để giúp đỡ! Bắt đầu cuộc trò chuyện và chúng tôi sẽ phản hồi sớm nhất có thể.",
  your_name_placeholder: "Tên của bạn",
  your_email_placeholder: "Địa chỉ email của bạn",
  start_chat_button: "Liên hệ hỗ trợ",
  start_chat_button_loading: "Đang kết nối...",
  i_need_more_help: "Tôi cần thêm trợ giúp",
  this_was_helpful: "Điều này hữu ích",
  optional: "Tùy chọn",
  no_conversations_yet: "Chưa có cuộc trò chuyện nào",
  back_to_conversations: "Quay lại cuộc trò chuyện",
  closed_conversations: "Cuộc trò chuyện đã đóng"
}, Se = {
  write_a_message_placeholder: "写一条消息...",
  your_issue_has_been_resolved: "您的问题已解决！",
  new_conversation: "新对话",
  welcome_screen_title: "欢迎使用我们的客服聊天",
  welcome_screen_description: "我们随时为您提供帮助！开始对话，我们会尽快回复您。",
  your_name_placeholder: "您的姓名",
  your_email_placeholder: "您的电子邮件地址",
  start_chat_button: "联系客服",
  start_chat_button_loading: "连接中...",
  i_need_more_help: "我需要更多帮助",
  this_was_helpful: "这很有帮助",
  optional: "可选",
  no_conversations_yet: "暂无对话",
  back_to_conversations: "返回对话",
  closed_conversations: "已关闭的对话"
}, Ce = {
  write_a_message_placeholder: "Napišite poruku...",
  your_issue_has_been_resolved: "Vaš problem je riješen!",
  new_conversation: "Novi razgovor",
  welcome_screen_title: "Dobrodošli u naš chat za podršku",
  welcome_screen_description: "Ovdje smo da pomognemo! Započnite razgovor i odgovorit ćemo vam što je prije moguće.",
  your_name_placeholder: "Vaše ime",
  your_email_placeholder: "Vaša e-mail adresa",
  start_chat_button: "Razgovarajte s podrškom",
  start_chat_button_loading: "Povezivanje...",
  i_need_more_help: "Trebam dodatnu pomoć",
  this_was_helpful: "Ovo je bilo korisno",
  optional: "Neobavezno",
  no_conversations_yet: "Još nema razgovora",
  back_to_conversations: "Natrag na razgovore",
  closed_conversations: "Zatvoreni razgovori"
}, xe = {
  write_a_message_placeholder: "Kirjuta sõnum...",
  your_issue_has_been_resolved: "Teie probleem on lahendatud!",
  new_conversation: "Uus vestlus",
  welcome_screen_title: "Tere tulemast meie tugiteenusesse",
  welcome_screen_description: "Oleme siin, et aidata! Alustage vestlust ja vastame teile esimesel võimalusel.",
  your_name_placeholder: "Teie nimi",
  your_email_placeholder: "Teie e-posti aadress",
  start_chat_button: "Räägi toega",
  start_chat_button_loading: "Ühendamine...",
  i_need_more_help: "Vajan rohkem abi",
  this_was_helpful: "See oli kasulik",
  optional: "Valikuline",
  no_conversations_yet: "Vestlusi pole veel",
  back_to_conversations: "Tagasi vestluste juurde",
  closed_conversations: "Suletud vestlused"
}, Ie = {
  write_a_message_placeholder: "Rakstiet ziņojumu...",
  your_issue_has_been_resolved: "Jūsu problēma ir atrisināta!",
  new_conversation: "Jauna saruna",
  welcome_screen_title: "Laipni lūdzam mūsu atbalsta tērzēšanā",
  welcome_screen_description: "Mēs esam šeit, lai palīdzētu! Sāciet sarunu, un mēs jums atbildēsim pēc iespējas ātrāk.",
  your_name_placeholder: "Jūsu vārds",
  your_email_placeholder: "Jūsu e-pasta adrese",
  start_chat_button: "Sazināties ar atbalstu",
  start_chat_button_loading: "Savienošana...",
  i_need_more_help: "Man vajag vairāk palīdzības",
  this_was_helpful: "Tas bija noderīgi",
  optional: "Neobligāts",
  no_conversations_yet: "Pagaidām nav sarunu",
  back_to_conversations: "Atpakaļ pie sarunām",
  closed_conversations: "Slēgtās sarunas"
}, Pe = {
  write_a_message_placeholder: "Schreift eng Noriicht...",
  your_issue_has_been_resolved: "Äert Problem gouf geléist!",
  new_conversation: "Nei Konversatioun",
  welcome_screen_title: "Wëllkomm bei eisem Support-Chat",
  welcome_screen_description: "Mir sinn hei fir ze hëllefen! Start eng Konversatioun a mir äntweren Iech esou séier wéi méiglech.",
  your_name_placeholder: "Ären Numm",
  your_email_placeholder: "Är E-Mail-Adress",
  start_chat_button: "Mat dem Support schwätzen",
  start_chat_button_loading: "Verbindung...",
  i_need_more_help: "Ech brauch méi Hëllef",
  this_was_helpful: "Dat war hëllefräich",
  optional: "Fakultativ",
  no_conversations_yet: "Nach keng Konversatiounen",
  back_to_conversations: "Zréck zu de Konversatiounen",
  closed_conversations: "Zougemaachte Konversatiounen"
}, ze = {
  write_a_message_placeholder: "Ikteb messaġġ...",
  your_issue_has_been_resolved: "Il-problema tiegħek ġiet riżolta!",
  new_conversation: "Konversazzjoni ġdida",
  welcome_screen_title: "Merħba fis-support chat tagħna",
  welcome_screen_description: "Aħna hawn biex ngħinu! Ibda konversazzjoni u nirrispondu malajr kemm jista' jkun.",
  your_name_placeholder: "Ismek",
  your_email_placeholder: "L-indirizz tal-email tiegħek",
  start_chat_button: "Kellem lis-support",
  start_chat_button_loading: "Qed jikkonnettja...",
  i_need_more_help: "Għandi bżonn aktar għajnuna",
  this_was_helpful: "Dan kien ta' għajnuna",
  optional: "Mhux obbligatorju",
  no_conversations_yet: "Għad m'hemmx konversazzjonijiet",
  back_to_conversations: "Lura għall-konversazzjonijiet",
  closed_conversations: "Konversazzjonijiet magħluqa"
}, O = {
  ar: W,
  bn: Z,
  bg: X,
  cs: Q,
  da: ee,
  de: se,
  el: te,
  en: ae,
  es: oe,
  et: xe,
  fi: ie,
  fil: ne,
  fr: re,
  hi: le,
  hr: Ce,
  it: ce,
  ja: _e,
  ko: he,
  lb: Pe,
  lv: Ie,
  mt: ze,
  nl: ue,
  no: de,
  pl: ge,
  pt: me,
  ro: pe,
  ru: be,
  sv: ve,
  th: fe,
  tr: we,
  ur: ye,
  vi: ke,
  "zh-cn": Se
}, Ae = Object.keys(O);
function Ue(_) {
  return Ae.includes(_);
}
function Le(_, a, n) {
  var r;
  return ((r = n == null ? void 0 : n[a]) == null ? void 0 : r[_]) || O[a][_] || "";
}
export {
  S as PrimitiveState,
  M as WidgetCtx,
  Le as getTranslation,
  B as isExhaustive,
  Ue as isSupportedLanguage
};
//# sourceMappingURL=index.js.map
